import { createRouter, createWebHistory } from "vue-router";
import Swal from "sweetalert2";
import { fetchAuthStatus } from "@/assets/Js/auth.js";

// 需要引入 SystemLayout 和 SystemDashboard 這兩個組件
import SystemLayout from "@/components/systemset/SystemLayout.vue";
import SystemDashboard from "@/components/systemset/SystemDashboard.vue";

const routes = [
  //顧客前台
  {
    path: "/",
    redirect: "/mainconsole",
  },
 

  //商家後臺
  {
    path: "/maincole/login",
    name: "login",
    component: () => import("@/components/LoginPage.vue"),
    meta: { hideFooter: true, requireLandscape: true }, // 添加這個元數據
  },
  {
    path: "/mainconsole",
    name: "mainconsole",
    component: () => import("@/components/MainConsole.vue"),
    meta: { hideFooter: true, requiresAuth: true, requireLandscape: true }, // ✅ 加上 requiresAuth，需要登入才可進入
  },
  {
    path: "/order/:tableId/:tableNumber", // ← 加上 tableNumber
    name: "OrderScreen",
    component: () => import("@/components/OrderScreen.vue"),
  },
  {
    path: "/order/:orderId", // 例如 /order/123?orderType=takeout
    name: "OrderScreenOther",
    component: () => import("@/components/OrderScreen.vue"),
    props: true,
  },
  {
    path: "/forgot",
    name: "forgot",
    component: () => import("@/components/ForgotPage.vue"),
    meta: { hideFooter: true, requireLandscape: true }, // 添加這個元數據
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: () => import("@/components/ResetPasswordConfirmPage.vue"),
    meta: { hideFooter: true }, // 密碼信件連結導向此頁；手機直向也可操作
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/components/RegisterPage.vue"),
    meta: { hideFooter: true, requireLandscape: true }, // 添加這個元數據
  },
  // 系統設定儀錶板路由配置
  {
    path: "/systemdashboard",
    name: "system-dashboard",
    component: SystemLayout,
    meta: { requiresAuth: true }, // 後台設定頁需要登入，由 /auth/status 驗證 HttpOnly Cookie
    children: [
      {
        path: "",
        name: "system-dashboard-home",
        component: SystemDashboard,
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true }, // 隱藏全局頁頭頁尾
      },
      {
        path: "store/hours",
        name: "hours",
        component: () => import("@/components/systemset/store/StoreHours.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "store/info",
        name: "storeinfo",
        component: () => import("@/components/systemset/store/StoreInfo.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        // 商家稅金設定已併入「商家資訊設定」頁籤，此路徑保留跳轉避免舊書籤失效
        path: "store/tax",
        redirect: "store/info",
      },
      {
        path: "store/cloudorder",
        name: "cloudorder",
        component: () =>
          import("@/components/systemset/store/StoreCloudOrder.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "customer/info",
        name: "customerinfo",
        component: () =>
          import("@/components/systemset/customer/CustomerInfo.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "customer/coopon",
        name: "customercoopon",
        component: () =>
          import("@/components/systemset/customer/CutomerCoopon.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "customer/history",
        name: "customerhistory",
        component: () =>
          import("@/components/systemset/customer/CutomerHistory.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "employee/account",
        name: "employeeaccount",
        component: () =>
          import("@/components/systemset/employee/EmployeeAccount.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "employee/attendance",
        name: "employeeattendance",
        component: () =>
          import("@/components/systemset/employee/EmployeeAttendance.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "employee/salary",
        name: "employeesalary",
        component: () =>
          import("@/components/systemset/employee/EmployeeSalary.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "menu/item",
        name: "item",
        component: () => import("@/components/systemset/menu/MenuItem.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "menu/itemaddons",
        name: "itemaddons",
        component: () => import("@/components/systemset/menu/ItemAddons.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "menu/combo",
        name: "menucombo",
        component: () => import("@/components/systemset/menu/MenuCombo.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "order/list",
        name: "orderlist",
        component: () => import("@/components/systemset/order/OrderList.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "order/auto",
        name: "orderauto",
        component: () => import("@/components/systemset/order/OrderAuto.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "table/number",
        name: "tablenumber",
        component: () => import("@/components/systemset/table/TableNumber.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "table/class",
        name: "tableclass",
        component: () => import("@/components/systemset/table/TableClass.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "table/state",
        name: "tablestate",
        component: () => import("@/components/systemset/table/TableState.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "table/reserve",
        name: "tablereserve",
        component: () =>
          import("@/components/systemset/table/TableReserve.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "table/auto",
        name: "tableauto",
        component: () => import("@/components/systemset/table/TableAuto.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "data/accounting",
        name: "reportaccounting",
        component: () => import("@/components/systemset/data/ReportGroup.vue"),
        meta: {
          hideHeader: true,
          hideFooter: true,
          requireLandscape: true,
          reportGroup: "accounting",
        },
      },
      {
        path: "data/analysis",
        name: "reportanalysis",
        component: () => import("@/components/systemset/data/ReportGroup.vue"),
        meta: {
          hideHeader: true,
          hideFooter: true,
          requireLandscape: true,
          reportGroup: "analysis",
        },
      },

      // 舊報表網址保留相容轉址，避免既有書籤失效。
      {
        path: "data/income",
        name: "dataincome",
        redirect: { path: "/systemdashboard/data/accounting", query: { tab: "summary" } },
      },
      {
        path: "data/daily",
        name: "reportdaily",
        redirect: { path: "/systemdashboard/data/accounting", query: { tab: "daily" } },
      },
      {
        path: "data/transactions",
        name: "reporttransactions",
        redirect: { path: "/systemdashboard/data/accounting", query: { tab: "todayTransactions" } },
      },
      {
        path: "data/hourly",
        name: "reporthourly",
        redirect: { path: "/systemdashboard/data/accounting", query: { tab: "hourly" } },
      },
      {
        path: "data/payment",
        name: "reportpayment",
        redirect: { path: "/systemdashboard/data/accounting", query: { tab: "payment" } },
      },
      {
        path: "data/consumption",
        name: "reportconsumption",
        redirect: { path: "/systemdashboard/data/analysis", query: { tab: "orderType" } },
      },
      {
        path: "data/seller",
        name: "dataseller",
        redirect: { path: "/systemdashboard/data/analysis", query: { tab: "product" } },
      },
      {
        path: "data/table-usage",
        name: "reporttableusage",
        redirect: { path: "/systemdashboard/data/analysis", query: { tab: "tableUsage" } },
      },
      {
        path: "data/table-status",
        name: "reporttablestatus",
        redirect: { path: "/systemdashboard/data/analysis", query: { tab: "tableStatus" } },
      },

      {
        path: "set/print",
        name: "setprint",
        component: () => import("@/components/systemset/set/SetPrint.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "set/api",
        name: "setapi",
        component: () => import("@/components/systemset/set/SetApi.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
      {
        path: "set/payment",
        name: "setpayment",
        component: () => import("@/components/systemset/set/SetPayment.vue"),
        meta: { hideHeader: true, hideFooter: true, requireLandscape: true },
      },
    ],
  },

  // ✅ 新增：404 錯誤頁面路由 - 必須放在所有路由的最後面
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/components/NotFound.vue"),
    meta: { hideHeader: true, hideFooter: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // 平滑滾動到頁面頂部
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, behavior: "smooth" };
    }
  },
});

// 全域前置守衛：統一向後端確認 HttpOnly Cookie 登入狀態
router.beforeEach(async (to, from, next) => {
  const isAuthPage = to.path === "/maincole/login" || to.path === "/register";
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiresAdmin =
    to.path === "/systemset" ||
    to.matched.some((record) => record.meta.requiresAdmin);

  const needStatusCheck = isAuthPage || requiresAuth || requiresAdmin;
  let authStatus = { authenticated: false };

  // =====================================================
  // 登入狀態檢查區域
  // -----------------------------------------------------
  // 不再用 Cookies.get("token") 判斷，因為 token 是 HttpOnly。
  // 這裡統一呼叫後端 /auth/status，由後端驗證 Cookie。
  // =====================================================
  if (needStatusCheck) {
    authStatus = await fetchAuthStatus({ force: true });
  }

  // 商家後台只接受 type=store。即使未來後端誤把其他 Cookie 回成 authenticated=true，
  // Router 也不能因此把使用者從登入頁彈回主控台。
  const isStoreAuthenticated =
    authStatus.authenticated === true && authStatus.type === "store";

  // 已登入的商家不應再進登入或註冊頁
  if (isAuthPage && isStoreAuthenticated) {
    next({ path: "/mainconsole" });
    return;
  }

  // 需要登入的頁面，必須通過後端 Cookie 驗證
  if (requiresAuth && !isStoreAuthenticated) {
    await Swal.fire({
      icon: "warning",
      title: "請先登入",
      text: "此頁面需要登入後才能使用。",
      confirmButtonText: "前往登入",
    });

    next({ path: "/maincole/login", query: { redirect: to.fullPath } });
    return;
  }

  // 需要管理員的頁面，必須由後端回傳的 role 判斷
  if (requiresAdmin) {
    if (!isStoreAuthenticated) {
      await Swal.fire({
        icon: "warning",
        title: "請先登入",
        text: "此頁面需要登入後才能確認權限。",
        confirmButtonText: "前往登入",
      });

      next({ path: "/maincole/login", query: { redirect: to.fullPath } });
      return;
    }

    if (authStatus.role !== "Admin") {
      await Swal.fire({
        icon: "error",
        title: "權限不足",
        text: "此頁面僅限管理員存取。",
        timer: 1500,
        showConfirmButton: false,
      });

      next({ path: "/mainconsole" });
      return;
    }
  }

  next();
});

export default router;
